;(function () {
  if (!window || !window.Shopify) return

  const CartEvents = {
    add: 'SCE:add',
    update: 'SCE:update',
    change: 'SCE:change',
    clear: 'SCE:clear',
    mutate: 'SCE:mutate',
  }

  function updateType(url) {
    if (!url) return false
    if (url.includes('cart/add')) {
      return 'add'
    } else if (url.includes('cart/update')) {
      return 'update'
    } else if (url.includes('cart/change')) {
      return 'change'
    } else if (url.includes('cart/clear')) {
      return 'clear'
    } else return false
  }

  function dispatchEvent(url, detail) {
   try {
     if (typeof detail === "string") {
      try {
        detail = JSON.parse(detail);
      } catch {}
    }
  

    if(url.includes('/cart.js')) {

        setTimeout(() => {
          window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
        }, 900);
        return;
    }
    const type = updateType(url);
    switch (type) {
      case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      default:
        break;
    }
   } catch (error) {
      console.error("Error dispatching cart event:", error);
   }
  }
//   function XHROverride() {
//     if (!window.XMLHttpRequest) return;

//     const originalOpen = window.XMLHttpRequest.prototype.open;
//     window.XMLHttpRequest.prototype.open = function () {
//       const url = arguments[1];
//       this.addEventListener("load", function () {
//           dispatchEvent(url, this.response);
//       });
//       return originalOpen.apply(this, arguments);
//     };
//   }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== 'function') return
    const originalFetch = window.fetch
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments)

      try {
        response
          .then((res) => {
            // Only process cart-related URLs
            // if (res.url && updateType(res.url)) {
              // Only try to parse JSON if content-type indicates JSON
                res
                  .clone()
                  .json()
                  .then((data) => {
                 
                    
                    dispatchEvent(res.url, data)})
                  .catch(() => {
                    // Silent fail for non-JSON responses
                  })
            // }
          })
          .catch(() => {
            // Silent fail for fetch errors
          })
      } catch (error) {
        // Silent fail for fetch override errors
      }

      return response
    }
  }

  fetchOverride()
//   XHROverride()
})()

function updateCartDisplay(price) {
  const cartItemsElement = document.querySelector('.cart-items > tbody')
  const value = 399

  if (price >= value) {
    const brindRow = document.querySelector('.cart-item.cart-brind-message')
    if (brindRow) {
      brindRow.remove()
      showHideStyle(false)
    }
    return
  }

  const calculatedPrice = value - Number(price || 0)

  const brindRowHTML = `
    <tr id="CartDrawer-Item-1" class="cart-item cart-brind-message" role="row">
      <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct" style="grid-column: 1 / -1;color:#202223;font-weight:bold;text-align:center;display: flex;border: 1px solid #937f53;padding: 10px;background: #937f533d;align-items: center;justify-content: center;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" version="1.1" style="width: 20px;height: 20px;margin-right: 10px;">
          <title>gift</title>
          <path d="M28 8.75h-0.211c0.548-0.833 0.874-1.854 0.874-2.952 0-0.448-0.054-0.884-0.157-1.3l0.008 0.037c-0.487-1.895-2.008-3.337-3.912-3.702l-0.031-0.005c-0.234-0.035-0.505-0.055-0.78-0.055-2.043 0-3.829 1.096-4.804 2.732l-0.014 0.026-2.973 4.279-2.974-4.279c-0.989-1.662-2.776-2.758-4.818-2.758-0.275 0-0.545 0.020-0.81 0.058l0.030-0.004c-1.935 0.37-3.455 1.812-3.934 3.672l-0.008 0.035c-0.095 0.379-0.149 0.815-0.149 1.263 0 1.097 0.326 2.119 0.886 2.972l-0.013-0.021h-0.212c-1.794 0.002-3.248 1.456-3.25 3.25v3c0.002 1.343 0.817 2.495 1.979 2.99l0.021 0.008v10.002c0.002 1.794 1.456 3.248 3.25 3.25h20c1.794-0.001 3.249-1.456 3.25-3.25v-10.002c1.183-0.503 1.998-1.656 2-2.998v-3c-0.002-1.794-1.456-3.248-3.25-3.25h-0zM28.75 12v3c-0.006 0.412-0.338 0.744-0.749 0.75h-10.751v-4.5h10.75c0.412 0.006 0.744 0.338 0.75 0.749v0.001zM21.027 4.957c0.544-1.009 1.593-1.683 2.8-1.683 0.104 0 0.207 0.005 0.309 0.015l-0.013-0.001c0.963 0.195 1.718 0.915 1.963 1.842l0.004 0.018c0.021 0.149 0.033 0.322 0.033 0.497 0 1.28-0.635 2.412-1.608 3.097l-0.012 0.008h-6.112zM5.911 5.147c0.248-0.944 1.002-1.664 1.949-1.857l0.016-0.003c0.092-0.010 0.199-0.015 0.307-0.015 1.204 0 2.251 0.675 2.783 1.667l0.008 0.017 2.636 3.793h-6.113c-0.984-0.692-1.619-1.823-1.619-3.101 0-0.177 0.012-0.351 0.036-0.521l-0.002 0.020zM3.25 12c0.006-0.412 0.338-0.744 0.749-0.75h10.751v4.5h-10.75c-0.412-0.006-0.744-0.338-0.75-0.749v-0.001zM5.25 28v-9.75h9.5v10.5h-8.75c-0.412-0.006-0.744-0.338-0.75-0.749v-0.001zM26.75 28c-0.006 0.412-0.338 0.744-0.749 0.75h-8.751v-10.5h9.5z"></path>
        </svg>
        <p class="cart-item__name h4 product-title-body break" style="color: #202223;text-align:center;">Faltam R$ ${calculatedPrice.toFixed(2).replace('.', ',')} para ganhar sua necessaire</p>
      </td>
    </tr>
  `


    if(document.querySelector('.cart-brind-message')) {
        document.querySelector('.cart-brind-message .cart-item__name').textContent = `Faltam R$ ${calculatedPrice.toFixed(2).replace('.', ',')} para ganhar sua necessarie`;
        return;
    }

    cartItemsElement.insertAdjacentHTML('afterbegin', brindRowHTML)
    showHideStyle(true)
}

function emptyCartDisplay() {
  const brindRowHTML = `
    <div class="cart-item__details empty-message" style="text-align:center;">
      <span class="cart-item__name h4 product-title-body break" style="color:#202223;font-weight:bold;text-align:center;">
        GANHE A NECESSAIRE OEJE
      </span>
      <span>
        Nas compras acima de <strong>R$399,00</strong> o item essencial da mala de verão é <strong>PRESENTE</strong>.
      </span>
    </div>
  `

  const emptyCartElement = document.querySelector('.drawer-inner-empty-cart-message')
  if (emptyCartElement && !document.querySelector('.cart-item__details.empty-message')) {
    emptyCartElement.insertAdjacentHTML('afterbegin', brindRowHTML)
  }
}

// Initialize empty cart display if cart is already empty
if (document.querySelector('.drawer-inner-empty-cart-message')) {
  emptyCartDisplay()
  showHideStyle(false)
}

// Listen for cart update events
window.addEventListener('SCE:mutate', (e) => {
  if (e.detail.item_count === 0) {
    emptyCartDisplay()
    return
  }
  updateCartDisplay(e.detail.total_price / 100)
})

showHideStyle()
function showHideStyle(show = true) {
  if (!show) {
    var existingStyle = document.getElementById('cart-drawer-fix-style')
    if (existingStyle) {
      existingStyle.remove()
    }
  }

  if( document.getElementById('cart-drawer-fix-style')) return;

  var s = document.createElement('style')
  s.id = 'cart-drawer-fix-style'
  s.innerHTML = `
  #CartDrawer-LineItemError-1 {
    display: none;
  }
`
  document.head.appendChild(s)
}
